<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="isEditMode ? 'Edit Upgrade' : 'Add Upgrade'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/home-outline.svg'"
              [label]="'Property'"
              formControlName="property_id"
              [form]="form.controls.property_id"
              [items]="propertyItems"
              [submitted]="submitted"
              [errorMessage]="'Please select a property.'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="name"
              [form]="form.controls.name"
              [label]="'Upgrade Name'"
              [icon]="'assets/svg/information-circle.svg'"
              [errorMessage]="'Please enter an upgrade name.'"
              [submitted]="submitted" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-textarea
              formControlName="description"
              [form]="form.controls.description"
              [label]="'Description'"
              [icon]="'assets/svg/create-outline.svg'" />
          </tidy-row>
        </tidy-card>

        <tidy-card>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="estimated_cost"
              [form]="form.controls.estimated_cost"
              [label]="'Estimated Cost ($)'"
              [icon]="'assets/svg/cash-outline.svg'"
              [type]="'number'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/trending-up-outline.svg'"
              [label]="'Impact'"
              formControlName="impact_score"
              [form]="form.controls.impact_score"
              [items]="impactItems" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="roi_score"
              [form]="form.controls.roi_score"
              [label]="'ROI Score (0-10)'"
              [icon]="'assets/svg/calculator-outline.svg'"
              [type]="'number'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/list.svg'"
              [label]="'Status'"
              formControlName="status"
              [form]="form.controls.status"
              [items]="statusItems" />
          </tidy-row>
        </tidy-card>

        <tidy-error-message
          [text]="errorMessage" />

        <tidy-button
          [text]="isEditMode ? 'Save Changes' : 'Add Upgrade'"
          [action]="boundSave"
          class="primary" />

        @if (isEditMode) {
          <tidy-button
            [text]="'Delete Upgrade'"
            [action]="boundDelete"
            class="secondary red" />
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
